import React from 'react';

export default (
	<svg
		width="48"
		height="48"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2413_7125)">
			<rect width="48" height="48" fill="#C3D6AD" />
			<path
				d="M6 5H42V0H43V5H48V6H43V42H48V43H43V48H42V43H6V48H5V43H0V42H5V6H0V5H5V0H6V5ZM6 42H42V6H6V42Z"
				fill="#506631"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2413_7125">
				<rect width="48" height="48" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
